import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const { theme } = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    // Close mobile menu when route changes
    setIsOpen(false);
  }, [location]);

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`} data-theme={theme}>
      <div className="navbar-container">
        <Link to="/" className="logo">
          <span className="logo-main">EBI</span>
          <span className="logo-sub">Education</span>
        </Link>

        <div className={`nav-links ${isOpen ? "open" : ""}`}>
          <NavLink
            to="/"
            currentPath={location.pathname}
            onClick={() => setIsOpen(false)}
          >
            Home
          </NavLink>
          <NavLink
            to="/fees"
            currentPath={location.pathname}
            onClick={() => setIsOpen(false)}
          >
            Fees
          </NavLink>
          <NavLink
            to="/notes"
            currentPath={location.pathname}
            onClick={() => setIsOpen(false)}
          >
            Notes
          </NavLink>
          <NavLink
            to="/about"
            currentPath={location.pathname}
            onClick={() => setIsOpen(false)}
          >
            About
          </NavLink>
          <NavLink
            to="/contact"
            currentPath={location.pathname}
            onClick={() => setIsOpen(false)}
          >
            Contact
          </NavLink>
        </div>

        <button
          className={`hamburger ${isOpen ? "open" : ""}`}
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

const NavLink = ({ to, currentPath, children, onClick }) => (
  <Link
    to={to}
    className={`nav-link ${currentPath === to ? "active" : ""}`}
    onClick={onClick}
  >
    <span className="nav-link-text">{children}</span>
    <span className="nav-link-underline"></span>
  </Link>
);

export default Navbar;